import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent: React.FC = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('whobrew_cookie_consent');
        if (!consent) {
            // Small delay to avoid flash on page load
            const timer = setTimeout(() => setShow(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('whobrew_cookie_consent', 'accepted');
        setShow(false);
    };

    const handleDecline = () => {
        localStorage.setItem('whobrew_cookie_consent', 'declined');
        setShow(false);
    };

    if (!show) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-40 p-4">
            <div className="max-w-4xl mx-auto bg-coffee-900 text-white rounded-2xl shadow-2xl p-6 flex flex-col sm:flex-row items-center gap-4">
                <div className="flex-1">
                    <p className="text-sm text-coffee-100">
                        <span className="font-semibold">Cookie Notice:</span> We use cookies to improve your experience and analyze site traffic.
                        By continuing, you agree to our{' '}
                        <Link to="/privacy" className="underline text-coffee-200 hover:text-white">Privacy Policy</Link>.
                    </p>
                </div>
                <div className="flex gap-3 flex-shrink-0">
                    <button
                        onClick={handleDecline}
                        className="px-4 py-2 text-sm text-coffee-300 hover:text-white transition-colors"
                    >
                        Decline
                    </button>
                    <button
                        onClick={handleAccept}
                        className="px-6 py-2 bg-coffee-600 hover:bg-coffee-500 text-white text-sm font-medium rounded-lg transition-colors"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
